import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInputLanguage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.35981 4.30469H4.00781V10.0007H8.35181V8.79269H5.35981V7.68069H8.08781V6.54469H5.35981V5.51269H8.35981V4.30469Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6962 5.49669C12.6962 6.52069 12.7042 7.40869 12.7282 8.14469C12.5362 7.76069 12.2402 7.24069 11.8402 6.57669L10.4482 4.30469H8.99219V10.0007H10.2802V8.80869C10.2802 7.78469 10.2642 6.91269 10.2482 6.17669C10.4082 6.50469 10.7042 7.02469 11.1362 7.72869L12.5282 10.0007H13.9842V4.30469H12.6962V5.49669Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4615 13.3088H10.2583L10.0829 13.4114L5.32692 16.1926V14.0588V13.3088H4.57692H2.94231C1.73153 13.3088 0.75 12.3273 0.75 11.1165V3C0.75 1.75736 1.75736 0.75 3 0.75H15C16.2426 0.75 17.25 1.75736 17.25 3V11.0588C17.25 12.3015 16.2426 13.3088 15 13.3088H10.4615Z",
			stroke: "black",
			strokeWidth: 1.5
		})
	]
});
export default SvgInputLanguage;
